/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable max-len */
<template>
  <div style="position:relative;">
    <!-- <div class="top-controls">
      <div class="controls">
        <v-tabs class="elevation-1" fixed-tabs>
          <v-tab v-on:click="groupBubbles()">Similarity</v-tab>
          <v-tab v-on:click="groupBubblesByCity()">City</v-tab>
          <v-tab v-on:click="groupBubblesByCategory()">Category</v-tab>
        </v-tabs>
      </div>
    </div> --> 
    <!-- <div class="top-controls">
      <v-select
          label="Solo field"
          dense
          solo
        >
          <v-select-item v-on:click="groupBubblesByCity()">City</v-select-item>
        </v-select>
    </div>-->
    <div ref="svgContainer" class="bubblechart-container">
      <div class="svg-container" :style="{width: settings.width + '%'}">
        <svg
          id="cluster-svg"
          pointer-events="all"
          :viewBox="'0 0 ' + svgWidth + ' ' + svgHeight + ''"
          preserveAspectRatio="xMinYMin meet"
        >
          <div v-if="!graph">Loading Please wait...</div>
          <g v-else class="nodes">
            <circle
              v-for="position in graph"
              @mouseover="
                bubbleMouseover(
                  position.title,
                  position.organization,
                  position.clustering.categories.map(function(keyword) {
                    return keyword.label
                  }))"
              @mousemove="bubbleMousemove"
              @click="bubbleClick(position)"
              @mouseout="bubbleMouseout"
              v-bind:key="position.id"
              :r="settings.circleRadius"
              v-bind:class="[
                position.match ? 'match' : '',
                getActivePosition.id === position.id ? 'active' : '',
                checkFavorite(position.id) ? 'favorite' : '',
                (position.clustering.categories[0]) ? position.clustering.categories[0].label.toLowerCase() : ''
              ]"
              cx="0"
              cy="0"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3';
import { debounce } from 'debounce';

export default {
  name: 'ClusterChart',

  props: {
    graph: {
      type: Array,
      required: true,
    },
    activePosition: {
      type: Object,
      required: false,
    },
    searchTerms: {
      required: false,
    },
  },

  data() {
    return {
      componentLoaded: false,
      activePositionID: 0,
      positionCount: 0,
      svgHeight: '0',
      svgWidth: '0',
      force: true,
      svg: null,
      nodes: null,
      simulation: null,
      tooltip: null,
      color: d3.scaleOrdinal(d3.schemePaired),
      settings: {
        width: 100,
        circleRadius: 4,
      },
    };
  },
  mounted() {
    this.getSvgContainerSizeAndInitChart();
    window.addEventListener('resize', this.onResize);
  },
  methods: {
    // eslint-disable-next-line func-names
    onResize: debounce(function () {
      this.getSvgContainerSizeAndInitChart();
    }, 300),
    initChart() {
      const that = this;
      this.svg = d3.select('#cluster-svg');
      this.nodes = this.svg.selectAll('circle').data(that.graph);

      this.simulation = d3
        .forceSimulation()
        .force('center', d3.forceCenter(that.svgWidth / 2, that.svgHeight / 2))
        .force('collision', d3.forceCollide(that.settings.circleRadius + 1))
        .force(
          'y',
          d3.forceY().y(d => d.clustering.position.y * that.svgHeight),
        )
        .force(
          'x',
          d3.forceX().x(d => d.clustering.position.x * that.svgWidth),
        );

      this.svg.call(
        d3
          .zoom()
          .translateExtent([[0, 0], [that.svgWidth, that.svgHeight]])
          .scaleExtent([0.5, 2])
          .on('zoom', () => {
            that.svg.selectAll('g').attr('transform', d3.event.transform);
          }),
      );

      if (!this.zoomContainer) {
        this.zoomContainer = this.svg
          .append('defs')
          .append('clipPath')
          .attr('id', 'clip')
          .append('rect')
          .attr('x', 0)
          .attr('y', 0)
          .attr('width', that.svgWidth)
          .attr('height', that.svgHeight);
      }
      if (!this.tooltip) {
        this.tooltip = d3
          .select('body')
          .append('div')
          .attr('class', 'tooltip');
      }
    },

    groupBubbles() {
      const that = this;
      that.simulation
        .force(
          'y',
          d3.forceY().y(d => d.clustering.position.y * that.svgHeight),
        )
        .force(
          'x',
          d3.forceX().x(d => d.clustering.position.x * that.svgWidth),
        );
      that.simulation.alpha(1).restart();
    },

    groupBubblesByCity() {
      const that = this;
      const { graph } = this;
      this.force = true;
      const centerScale = d3
        .scalePoint()
        .padding(2)
        .range([0, this.svgWidth]);
      centerScale.domain(
        graph.map(d => d.location.city),
      );
      that.simulation
        /* .force(
          "y",
          d3.forceY().y(function(d) {
            return d.clustering.position.y * that.svgHeight;
          })
        ) */
        .force(
          'x',
          d3.forceX().x(d => centerScale(d.location.city)),
        );
      that.simulation.alpha(1).restart();
    },

    groupBubblesByCategory() {
      const that = this;
      const { graph } = this;
      this.force = true;
      const centerScale = d3
        .scalePoint()
        .padding(1)
        .range([0, this.svgWidth]);
      centerScale.domain(
        graph.map(d => (d.clustering.categories.length ? d.clustering.categories[0].label : '-')),
      );
      that.simulation
        /* .force(
          "y",
          d3.forceY().y(function(d) {
            return that.svgHeight / 2;
          })
        ) */
        .force(
          'x',
          d3.forceX().x(d => centerScale(d.clustering.categories.length ? d.clustering.categories[0].label : '-')),
        );
      that.simulation.alpha(1).restart();
    },

    bubbleMouseover(title, company, keywords) {
      function checkTrim(myString) {
        if (myString.length > 40) {
          return myString.substring(0, 42) + '...'
        }
        return myString;
      }
      this.tooltip
        .html(`
          <div style="width:100%;padding-bottom:0.3rem;font-size:16px;">
            ${checkTrim(title)}
          </div>
          <div style="width:100%;padding-top:0.3rem;font-size:14px;">
            ${checkTrim(company)}
          </div>
        `) // <span style="font-size: 70%">${(keywords.length ? keywords[0] : '-').toUpperCase()}</span>
        .classed('visible', true)
        .style(
          'transform',
          `translate(${event.pageX}px, ${event.pageY - 82}px)`,
        );
    },
    bubbleClick(position) {
      if(this.activePositionID == position.id){
        this.updateSelectedPosition(null);
        this.getSvgContainerSizeAndInitChart();
      }
      else{
        this.updateSelectedPosition(position);
        this.activePositionID = position.id;
      }
    },
    bubbleMouseout() {
      this.tooltip.classed('visible', false);
    },
    bubbleMousemove() {
      this.tooltip.style(
        'transform',
        `translate(${event.pageX}px, ${event.pageY - 82}px)`,
      );
    },

    // Method to update data to vuex store
    updateSelectedPosition(position) {
      this.$store.dispatch('commitSelectedPosition', position);
    },

    getSvgContainerSizeAndInitChart() {
      if (
        this.$refs.svgContainer.clientHeight
        && this.$refs.svgContainer.clientWidth
      ) {
        const heightString = `${this.$refs.svgContainer.clientHeight}`;
        const widthString = `${this.$refs.svgContainer.clientWidth}`;
        this.svgHeight = heightString;
        this.svgWidth = widthString;
        this.componentLoaded = true;
        this.initChart();
      }
    },
    checkFavorite(id) {
      return this.$store.state.userFavorites.findIndex(item => item.id == id) > -1;
    }
  },
  computed: {
    getActivePosition(){
      let selectedPosition = this.$store.state.selectedPosition;
      if(selectedPosition == null) selectedPosition = {id: null};
      this.activePositionID = selectedPosition.id;
      return selectedPosition;
    }
  },
  updated() {
    const that = this;
    const { simulation } = this;
    const { nodes } = this;
    if (this.componentLoaded) {
      simulation.nodes(that.graph).on('tick', () => {
        nodes
          .attr('cx', (d) => {
            const boundsCheckedX = Math.max(
              that.settings.circleRadius,
              Math.min(that.svgWidth - that.settings.circleRadius, d.x),
            );
            return boundsCheckedX.toFixed(3);
          })
          .attr('cy', (d) => {
            const boundsCheckedY = Math.max(
              that.settings.circleRadius,
              Math.min(that.svgHeight - that.settings.circleRadius, d.y),
            );
            return boundsCheckedY.toFixed(3);
          });
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style>

.bubblechart-container {
  position: relative;
  height: 320px;
}
svg {
  display: block;
  margin: 0 auto;
}
.top-controls {
  display: flex;
  width: 100%;
}
.controls {
  width: 100%;
  padding: 00em;
  align-items: right;
  display: flex;
  flex-direction: column;
}

.svg-container {
  display: table;
}

.controls > * + * {
  margin-top: 1rem;
}

label {
  display: block;
}

.nodes circle {
  stroke: #fff;
  stroke-width: 3px;
  position: relative;
  fill: #dcdcdc;
}
.nodes circle:hover {
  cursor: pointer;
  fill: #000;
}
.nodes circle.match {
  stroke-width: 1px;
  fill: rgba(0, 45, 160, 1);
}

circle.match.active {
  stroke-width: 2px;
  stroke: rgba(0, 45, 160, 1);
  fill: #fff !important;
}

circle.active {
  stroke-width: 2px;
  stroke: #bdbdbd;
  fill: #fff !important;
}

circle.favorite,
circle.active.favorite {
  stroke-width: 2px !important;
  stroke: #0b7724 !important;
  fill: #0b772480 !important;
}

.ripple-effect {
  display: block;
  position: absolute;
  content: '';
  width: 32px;
  height: 32px;
  background: red;
  border-radius: 100%;
}

circle.match.academic { fill :#0078a5 }
circle.match.active.academic { stroke: #0078a5 }

circle.match.ict { fill: #414548 }
circle.match.active.ict { stroke: #414548 }

circle.match.engineering { fill: #42899c }
circle.match.active.engineering { stroke: #42899c }

circle.match.health { fill: #96b98f }
circle.match.active.health { stroke: #96b98f }

circle.match.experience { fill: #ab0a7d }
circle.match.active.experience { stroke: #ab0a7d }


.tooltip {
  position: absolute;
  text-align: left;
  top: 0;
  left: 0;
  box-sizing: border-box;
  z-index: 10;
  width: auto;
  max-width: 320px;
  padding: 1em;
  background: #fff;
  border-radius: 3px;
  pointer-events: none;
  font-size: 0.8em;
  opacity: 0;
  font-family: "Finlandica", sans-serif;
  transition: opacity 0.1s linear;
  box-shadow: 0px 6px 20px rgba(0,0,0,.3);
}
.tooltip.visible {
  opacity: 1;
}

@media screen and (min-width: 960px) {
  .bubblechart-container {
    position:relative; height: calc(90vh - 273px - 32px);
  }
}
</style>
